import React, {
  memo, useContext, useMemo,
} from 'react';
import 'ol/ol.css';
import { Progress, Spin } from 'antd';
import MapViewContext from 'contexts/MapViewContext';
import styles from './index.module.scss';
import FeaturesPopup from './components/FeaturesPopup';
import MainAppContext from '../../../../../../../../contexts/MainAppContext';
import CrossSectionModal from './components/CrossSectionWindow';
import TimeSeriesContext from '../../../../../../../../contexts/TimeSeriesContext';
import GoCenterButton from './components/GoCenterButton';

const { spinner, charger } = styles;

interface MemoMapProps {
  loadingLayer: boolean,
  playbackMode: boolean,
  realTimeMode: boolean,
  loadingAnimationCharge: number | null,
  isPreloading: boolean,
  mapContainer: React.RefObject<HTMLDivElement> | undefined
}

const MemoMap = memo(({
  loadingLayer,
  playbackMode,
  loadingAnimationCharge,
  isPreloading,
  mapContainer,
  realTimeMode,
} : MemoMapProps) => {
  const showProgress = loadingAnimationCharge !== null;
  const showSpinner = loadingLayer
    && !playbackMode
    && !showProgress
    // && !realTimeMode
    && !loadingAnimationCharge;
  return (
    <>
      {showSpinner && <Spin className={spinner} />}
      {showProgress && <Progress percent={Math.trunc(loadingAnimationCharge)} steps={5} size="small" className={charger} />}
      <div ref={mapContainer} style={{ height: '100%', position: 'relative' }}>
        <FeaturesPopup />
        <CrossSectionModal />
        <GoCenterButton style={{
          position: 'absolute',
          zIndex: 10,
          bottom: '86px',
          left: '9px',
        }}
        />
      </div>
    </>
  );
}, (prev, next) => prev.loadingLayer === next.loadingLayer
&& prev.playbackMode === next.playbackMode
&& prev.loadingAnimationCharge === next.loadingAnimationCharge
&& prev.isPreloading === next.isPreloading);

function Map() {
  const {
    mapContainer,
    loadingLayer,
    loadingAnimationCharge,

  } = useContext(MapViewContext);
  const { playbackMode, realTimeMode } = useContext(MainAppContext);
  const {
    preloadingState,
  } = useContext(TimeSeriesContext);
  const isPreloading = useMemo(() => preloadingState.some((s) => s === 'active'), [preloadingState]);

  return (
    <MemoMap
      loadingLayer={loadingLayer}
      playbackMode={playbackMode}
      loadingAnimationCharge={loadingAnimationCharge}
      isPreloading={isPreloading}
      mapContainer={mapContainer}
      realTimeMode={realTimeMode}
    />
  );
}

export default Map;
